import { Controller } from "stimulus";

export default class extends Controller {
  toggleExpanded() {
    this.element.classList.toggle("expanded");
  }
}
